import React from 'react';
import AppSwitch from '../../../components/atoms/AppSwitch/AppSwitch';

interface SwitchCriteriaFormProps {
  onChange: (e: boolean) => void;
  checkPrefix?: string;
  checkSuffix?: string;
  checked: boolean;
}

export const SwitchCriteriaForm = ({ checkPrefix, checked, checkSuffix, onChange }: SwitchCriteriaFormProps) => {
  const [dataForm, setData] = React.useState(checked);

  return (
    <div className="flex w-full items-center h-11">
      {checkPrefix && <p className="mr-2">{checkPrefix}</p>}
      <AppSwitch checked={dataForm} onChange={(v) => {
        setData(v);
        onChange(v);
      }} />
      {checkSuffix && <p className="ml-2">{checkSuffix}</p>}
    </div>
  );
};
